// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Employee_item__dk\\+iL {
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.0509803922);
  background-color: var(--white);
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  padding: 16px 8px 16px 16px;
}
@media (min-width: 640px) {
  .Employee_item__dk\\+iL {
    padding-right: 16px;
  }
}
.Employee_item--sm__wL98X {
  border-radius: 0;
  box-shadow: none;
  padding: 6px 8px 6px 4px;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid #E0E7EB;
  cursor: pointer;
}
@media (hover: hover) {
  .Employee_item--sm__wL98X:hover {
    background-color: var(--accent-color);
    color: var(--white);
  }
}
.Employee_item--sm__wL98X:last-child {
  border: none;
}
.Employee_item--sm__wL98X .Employee_content__8uoRn {
  display: flex;
  padding-right: 0;
}
.Employee_item--sm__wL98X .Employee_imgDummy__gnBFh,
.Employee_item--sm__wL98X .Employee_avatar__ECwX0 {
  width: 24px;
  height: 24px;
  font-size: 11px;
  line-height: normal;
}
.Employee_item--sm__wL98X .Employee_name__masHL {
  margin: 0 0 0 8px;
}
.Employee_item--sm__wL98X br {
  display: none;
}

.Employee_content__8uoRn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding-right: 10px;
}

.Employee_name__masHL {
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 8px;
}

.Employee_highlight__3fDpD {
  background-color: #FFF742;
}

.Employee_position__S8ycW,
.Employee_link__p-Nl3 {
  color: #7A808B;
  font-size: 14px;
  line-height: 16px;
}

.Employee_position__S8ycW,
.Employee_link__p-Nl3 {
  margin-bottom: 8px;
}

.Employee_link__p-Nl3 {
  display: inline-block;
  border-bottom: 1px solid currentColor;
  transition: var(--transition);
}
@media (hover: hover) {
  .Employee_link__p-Nl3:hover {
    border-color: transparent;
  }
}

.Employee_btn__zK5WU {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #EEEEEE;
  min-height: 24px;
  border-radius: 12px;
  font-size: var(--fz-sm);
  line-height: var(--lh-sm);
  padding: 2px 14px 2px 12px;
  transition: var(--transition);
  margin-top: 4px;
}
@media (hover: hover) {
  .Employee_btn__zK5WU:hover {
    opacity: 0.8;
  }
}
.Employee_btn__zK5WU .btn-loader {
  left: 4px;
}
.Employee_btn--is-loading__Hgg\\+R svg {
  opacity: 0;
}
.Employee_btn__zK5WU svg {
  flex-shrink: 0;
  color: var(--accent-color);
  margin-right: 7px;
}

.Employee_phoneWrap__4El-G {
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/Employees/Employee/Employee.module.scss"],"names":[],"mappings":"AAAA;EACE,uDAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,2BAAA;AACF;AACE;EARF;IASI,mBAAA;EAEF;AACF;AAAE;EACE,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;AAEJ;AAAI;EACE;IACE,qCAAA;IACA,mBAAA;EAEN;AACF;AACI;EACE,YAAA;AACN;AAEI;EACE,aAAA;EACA,gBAAA;AAAN;AAGI;;EAEE,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AADN;AAII;EACE,iBAAA;AAFN;AAKI;EACE,aAAA;AAHN;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;AALF;;AAQA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;;EAEE,cAAA;EACA,eAAA;EACA,iBAAA;AALF;;AAQA;;EAEE,kBAAA;AALF;;AAQA;EACE,qBAAA;EACA,qCAAA;EACA,6BAAA;AALF;AAOE;EACE;IACE,yBAAA;EALJ;AACF;;AASA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,eAAA;AANF;AAQE;EACE;IACE,YAAA;EANJ;AACF;AAUI;EACE,SAAA;AARN;AAaI;EACE,UAAA;AAXN;AAeE;EACE,cAAA;EACA,0BAAA;EACA,iBAAA;AAbJ;;AAiBA;EACE,gBAAA;AAdF","sourcesContent":[".item {\r\n  box-shadow: 0px 5px 9px 0px #0000000D;\r\n  background-color: var(--white);\r\n  border-radius: 12px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 16px 8px 16px 16px;\r\n\r\n  @media (min-width: 640px) {\r\n    padding-right: 16px;\r\n  }\r\n\r\n  &--sm {\r\n    border-radius: 0;\r\n    box-shadow: none;\r\n    padding: 6px 8px 6px 4px;\r\n    flex-direction: row-reverse;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    border-bottom: 1px solid #E0E7EB;\r\n    cursor: pointer;\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        background-color: var(--accent-color);\r\n        color: var(--white);\r\n      }\r\n    }\r\n\r\n    &:last-child {\r\n      border: none;\r\n    }\r\n\r\n    .content {\r\n      display: flex;\r\n      padding-right: 0;\r\n    }\r\n\r\n    .imgDummy,\r\n    .avatar {\r\n      width: 24px;\r\n      height: 24px;\r\n      font-size: 11px;\r\n      line-height: normal;\r\n    }\r\n\r\n    .name {\r\n      margin: 0 0 0 8px;\r\n    }\r\n\r\n    br {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  padding-right: 10px;\r\n}\r\n\r\n.name {\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  line-height: 18px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.highlight {\r\n  background-color: #FFF742;\r\n}\r\n\r\n.position,\r\n.link {\r\n  color: #7A808B;\r\n  font-size: 14px;\r\n  line-height: 16px;\r\n}\r\n\r\n.position,\r\n.link {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.link {\r\n  display: inline-block;\r\n  border-bottom: 1px solid currentColor;\r\n  transition: var(--transition);\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      border-color: transparent;\r\n    }\r\n  }\r\n}\r\n\r\n.btn {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: #EEEEEE;\r\n  min-height: 24px;\r\n  border-radius: 12px;\r\n  font-size: var(--fz-sm);\r\n  line-height: var(--lh-sm);\r\n  padding: 2px 14px 2px 12px;\r\n  transition: var(--transition);\r\n  margin-top: 4px;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n\r\n  :global {\r\n    .btn-loader {\r\n      left: 4px;\r\n    }\r\n  }\r\n\r\n  &--is-loading {\r\n    svg {\r\n      opacity: 0;\r\n    }\r\n  }\r\n\r\n  svg {\r\n    flex-shrink: 0;\r\n    color: var(--accent-color);\r\n    margin-right: 7px;\r\n  }\r\n}\r\n\r\n.phoneWrap {\r\n  margin-top: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `Employee_item__dk+iL`,
	"item--sm": `Employee_item--sm__wL98X`,
	"content": `Employee_content__8uoRn`,
	"imgDummy": `Employee_imgDummy__gnBFh`,
	"avatar": `Employee_avatar__ECwX0`,
	"name": `Employee_name__masHL`,
	"highlight": `Employee_highlight__3fDpD`,
	"position": `Employee_position__S8ycW`,
	"link": `Employee_link__p-Nl3`,
	"btn": `Employee_btn__zK5WU`,
	"btn--is-loading": `Employee_btn--is-loading__Hgg+R`,
	"phoneWrap": `Employee_phoneWrap__4El-G`
};
export default ___CSS_LOADER_EXPORT___;
